export const CAModalBackground = 'rgba(255, 255, 255, .75)';
export const CAModalBorderRadius = '25px';
export const CAButtonBorderRadius = '50px';
